<template lang="pug" src='./office-modal.pug'></template>

<script>
import Icon from 'components/icon/icon'

export default {
  data () {
    return {
      swiperOption: {
        speed: 550
      }
    }
  },
  computed: {
    mySwiper () {
      return this.$refs.myOfficeSwiper.swiper
    }
  },
  props: [ 'props' ],
  components: {
    Icon
  },
  methods: {
    closeModal () {
      this.$store.dispatch('VIEW_OFFICE', false)
      document.body.classList.remove('body-stop')
    },
    slidePrev () {
      this.mySwiper.slidePrev()
    },
    slideNext () {
      this.mySwiper.slideNext()
    }
  }
}
</script>



// WEBPACK FOOTER //
// office-modal.vue?365366e8